import {Component, Input} from '@angular/core';
import {User} from '../../models/user';
import {Translations} from '../../services/translations.service';
import {SessionStorageService} from '../../services/session-storage.service';
import {Router} from '@angular/router';
import {RoutingConstants} from '../../models/routing/routing-constants';
import {Button} from 'primeng/button';
import {StyleClass} from 'primeng/styleclass';
import {PrimeTemplate} from 'primeng/api';
import {Ripple} from 'primeng/ripple';
import {DialogService} from 'primeng/dynamicdialog';
import {ChangePasswordComponent} from '../change-password/change-password.component';

@Component({
  standalone: true,
  selector: 'app-profile-button',
  templateUrl: './profile-button.component.html',
  imports: [
    Button,
    StyleClass,
    PrimeTemplate,
    Ripple
  ],
  styleUrls: ['./profile-button.component.scss']
})
export class ProfileButtonComponent {

    @Input() user!: User;

    protected readonly RoutingConstants = RoutingConstants;

    constructor(
        public translations: Translations,
        private sessionService: SessionStorageService,
        private router: Router,
        private dialogService: DialogService,
    ) {
    }

    async logout() {
        this.sessionService.reset();
        this.router.navigateByUrl(RoutingConstants.login);
    }

    openProfile() {
        ChangePasswordComponent.openDialog(this.dialogService);
    }

    openSettings() {
        this.router.navigateByUrl(RoutingConstants.settings);
    }
}
